import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { enterCall, getConsent } from "../../redux/actions/call";
import Error from "../commons/errors/Error";
import Overlay from "../commons/loading/Overlay";
import CallContainer from "./call/CallContainer";
import ConsentModal from "./consent/ConsentModal";

const RoomContainer = () => {
  const dispatch = useDispatch();
  const { code } = useSelector((state) => state.error);
  const consent = useSelector((state) => state.call.consent);
  const call = useSelector((state) => state.call.call);
  const [searchParams] = useSearchParams();
  const idRoom = searchParams.get("id") ?? searchParams.get("Id");

  useEffect(() => {
    dispatch(getConsent(idRoom)).then((res) => {
      const values = res?.value;
      if (
        values === null ||
        !values?.esPaciente ||
        !values?.solicitaConsentimiento ||
        values.consentimiento === true
      ) {
        dispatch(enterCall(idRoom));
      }
    });
  }, [idRoom, dispatch]);

  if (code) {
    return <Error />;
  }

  const showConsentModal =
    consent.data?.esPaciente &&
    consent.data?.solicitaConsentimiento &&
    consent.data?.consentimiento !== true &&
    !call.data?.accessToken;

  if (showConsentModal) {
    return (
      <ConsentModal
        idRoom={idRoom}
        consentText={consent.data.textoConsentimiento}
      />
    );
  }

  if (call.data?.accessToken) {
    return <CallContainer />;
  }
  return <Overlay />;
};

export default RoomContainer;